import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { search_icon, view_icon } from "../../../assets/imgs";
import { Table } from "../../../components/Table/Table";

const UserRoles = () => {
  const navigate = useNavigate();

  const [page, setPage] = useState(1);

  const [pagination, setPagination] = useState("");

  const [popup, setPopup] = useState(false);

  const [owners, setOwners] = useState([
    {
      "S.No": "01",
      adminID: "Rob90",
      name: "Robert",
      Owner: "Sathish (Rob90)",
      role: "Group 1",
      "Registered Date": "12/02/2025",
      email: "robert@gmail.com",
      number: "2345678974",
      City: "Chennai",
      "Total Property Count": 12,
      status: "off",
    },
    {
      "S.No": "01",
      adminID: "Thor91",
      name: "Thor",
      Owner: "Sathish (Rob90)",
      role: "Group 2",
      "Registered Date": "12/02/2025",
      email: "thor@gmail.com",
      number: "2345678974",
      City: "Chennai",
      "Total Property Count": 12,
      status: "off",
    },
    {
      "S.No": "01",
      adminID: "Rob90",
      name: "Robert",
      Owner: "Sathish (Rob90)",
      role: "Group 3",
      "Registered Date": "12/02/2025",
      email: "robert@gmail.com",
      number: "2345678974",
      City: "Chennai",
      "Total Property Count": 12,
      status: "off",
    },
  ]);

  const handleStatus = ({ id }) => {
    const updatedData = [...owners]; // Create a copy of the data
    const currentStatus = updatedData[id].status || "on"; // Default to "on" if undefined

    updatedData[id].status = currentStatus === "on" ? "off" : "on";
    setOwners(updatedData);
    console.log("KK", id);
    // let value = data.filter((ele, i) => i == id ? ele.status == "off" ? "on" : "off")
  };

  const columns = React.useMemo(
    () => [
      {
        Header: "S.No",
        accessor: "",
        Cell: ({ value, row }) => {
          return <p>{(page - 1) * 10 + row.index + 1}</p>;
        },
      },

      {
        Header: "Role",
        accessor: "role",
        Cell: ({ value, row }) => {
          return <p>{value}</p>;
        },
      },
      //   {
      //     Header: "Status",
      //     accessor: "status",
      //     Cell: ({ value, row }) => {
      //       return (
      //         <div>
      //           {row.original.role != "Super Admin" && (
      //             <button
      //               onClick={() => {
      //                 // if (givenpermissions?.includes("CAN-Status-ADMINS")) {
      //                 handleStatus(row);
      //                 // handleStatus(row.original.id);
      //                 // }
      //               }}
      //               className={`${
      //                 value == "off" ? "deactive-btn" : "active-btn"
      //               } border-0 f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-13 fs-xxl-18`}
      //             >
      //               {value == "off" ? "De-active" : " Active"}
      //             </button>
      //           )}
      //         </div>
      //       );
      //     },
      //   },
      {
        Header: "Action",
        accessor: "",
        Cell: ({ value, row }) => {
          return (
            <React.Fragment>
              <button
                onClick={() => {
                  navigate("/companyUserAddRoles", { state: { type: "view" } });
                }}
                className="cust-btn "
              >
                <img src={view_icon} alt="" className="mx-2 edit-btn " />
              </button>
            </React.Fragment>
          );
        },
      },
    ],
    [page]
  );

  return (
    <div className="dashRightView">
      <div className="d-flex ac-jb">
        <h2 className=" f3 fs-sm-16 fs-md-20 fs-lg-22 fs-xl-24 fs-xxl-26 ">
          Total:{owners.length}
        </h2>
        <div className="d-flex gap-3">
          <div className="search-input">
            <input
              //  onChange={(e) => (adminList(1, e.target.value))}
              type="text"
              placeholder="Search"
              style={{ border: "none", width: "150px" }}
            />
            <img src={search_icon} className="search" />
          </div>
        </div>
      </div>
      <Table
        columns={columns}
        setPageno={setPage}
        pagecount={pagination}
        data={owners}
        show={true}
      />
      {popup && (
        <div className="img-popup-design">
          <div className="img-popup">
            <p className="f3 ms-2  ms-md-2 ms-lg-2 ms-xl-2 fs-xs-10 fs-sm-11 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-15 mt-4">
              Are you sure, want to Delete?
            </p>
            <div className="d-flex ac-jb px-2 mt-5">
              <button onClick={() => setPopup(false)} className="add-btn w-40">
                Yes
              </button>
              <button
                onClick={() => {
                  setPopup(false);
                  // logout();
                }}
                className="back-btn f2 w-40"
              >
                {/* {loading ? "Loading..." : "Confirm"} */}No
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default UserRoles;
